import { render, staticRenderFns } from "./GroupQRCode.vue?vue&type=template&id=372fc7b8&scoped=true&"
import script from "./GroupQRCode.vue?vue&type=script&lang=js&"
export * from "./GroupQRCode.vue?vue&type=script&lang=js&"
import style0 from "./GroupQRCode.vue?vue&type=style&index=0&id=372fc7b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372fc7b8",
  null
  
)

component.options.__file = "GroupQRCode.vue"
export default component.exports